import { useLayoutEffect, useRef, useEffect, useState } from 'react'
import * as am5 from '@amcharts/amcharts5'
import * as am5xy from '@amcharts/amcharts5/xy'
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated'
import { getSurveyCompletion } from '../../../../services/analytics/analytics.service'
import Loading from '../../../Loading/Loading'

const Chart = ({ data }) => {
  const chartRef = useRef(null)

  useLayoutEffect(() => {
    if (!data.length) return
    const root = am5.Root.new(chartRef.current)
    root.setThemes([am5themes_Animated.new(root)])
    root._logo.dispose()
    const chart = root.container.children.push(
      am5xy.XYChart.new(root, { panX: false, panY: false, layout: root.verticalLayout })
    )
    const yAxis = chart.yAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: 'survey_name',
        renderer: am5xy.AxisRendererY.new(root, { minGridDistance: 20 })
      })
    )
    const xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererX.new(root, {}),
        min: 0,
        max: 100,
        strictMinMax: true
      })
    )
    const series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: 'Completion %',
        xAxis,
        yAxis,
        valueXField: 'completion_pct',
        categoryYField: 'survey_name',
        tooltip: am5.Tooltip.new(root, {
          labelText: '{survey_name}: {valueX}% ({submitted}/{total})'
        })
      })
    )
    series.columns.template.setAll({
      fill: am5.color(0x27ae60),
      stroke: am5.color(0x27ae60),
      cornerRadiusTR: 4,
      cornerRadiusBR: 4
    })
    const chartData = data.map((d) => ({ ...d, survey_name: d.survey_name || d.survey_id }))
    yAxis.data.setAll(chartData)
    series.data.setAll(chartData)
    series.appear(1000)
    chart.appear(1000, 100)
    return () => root.dispose()
  }, [data])

  return <div ref={chartRef} style={{ width: '100%', height: Math.max(200, data.length * 40) }} />
}

const SurveyCompletion = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    getSurveyCompletion()
      .then((res) => setData(res?.data || []))
      .catch((err) => setError(err?.message || 'Error loading survey completion'))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <Loading />
  if (error)
    return (
      <div style={{ padding: 24, color: '#c0392b' }}>
        <strong>Error:</strong> {error}
      </div>
    )
  if (!data.length) return <p style={{ color: '#888', padding: 24 }}>No survey data available.</p>

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 16, fontSize: 18, fontWeight: 600, color: '#2b5784' }}>
        Survey Completion Rate
      </h2>
      <Chart data={data} />
    </div>
  )
}

export default SurveyCompletion
